import { useState, useEffect } from 'react';

export function useStudentState() {
  const [student, setStudent] = useState({
    name: 'Alice Hartwell',
    avatar: 'AH',
    email: 'alice@example.com'
  });

  const [toast, setToast] = useState<{ message: string; type: 'success' | 'error' | 'info' | 'warning' } | null>(null);

  useEffect(() => {
    // Mock initializing student data
    const loadStudent = () => {
      const saved = localStorage.getItem('userData');
      if (saved) {
        const user = JSON.parse(saved);
        setStudent({
          name: user.username,
          avatar: user.username.charAt(0).toUpperCase(),
          email: user.email
        });
      }
    };
    loadStudent();
  }, []);

  const showToast = (message: string, type: 'success' | 'error' | 'info' | 'warning' = 'info') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  };

  return { student, toast, showToast };
}
